import React from 'react';
import { useDynamicPWA } from '@/hooks/useDynamicPWA';

interface PWAProviderProps {
  children: React.ReactNode;
}

export const PWAProvider: React.FC<PWAProviderProps> = ({ children }) => {
  // Initialize dynamic PWA functionality
  useDynamicPWA();

  return <>{children}</>;
};